module.exports = __webpack_public_path__ + "static/media/RightWhiteArrow.cb926471.svg";